import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import { useState } from "react";
import { useHistory } from "react-router";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { THEME_MODE } from "src/config/constants";
import { getFavoriteTokens, removeFavoriteToken } from "src/services/favoriteToken";

const useStyle = makeStyles((theme) => ({
  butContainer: {
    background: theme.palette.type === THEME_MODE.DARK ? "#031527" : "#E6EBF4",
    padding: "0.5rem",
    margin: "0.25rem",
    borderRadius: "6px",
    cursor: "pointer",
  },
  icon: {
    cursor: "pointer",
    fontSize: "16px",
    marginLeft: "0.5rem",
    color: theme.palette.text.secondary,
  },
}));

export default function YourFavoriteToken() {
  const cls = useStyle();
  const history = useHistory();
  const [favoriteToken, setFavoriteToken] = useState(getFavoriteTokens());

  const onRemoveFavoriteTokenClick = (event, tokenId) => {
    event.stopPropagation();
    removeFavoriteToken(tokenId);
    setFavoriteToken(getFavoriteTokens());
  };

  const onTokenClick = (tokenId) => {
    history.push(`/tokens-health/${tokenId}`);
  };

  const onAddFavoriteTokenClick = () => {
    history.push("/tokens-health");
  };

  return (
    <PaperWrapper title="Your Favorite Tokens" style={{ paddingTop: "2rem" }}>
      <Box display="flex" flexWrap="wrap">
        {favoriteToken.length > 0 ? (
          <>
            {favoriteToken.map((element, index) => {
              return (
                <Box
                  key={index}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  className={cls.butContainer}
                  onClick={() => onTokenClick(element)}
                >
                  <Typography variant="subtitle2" color="textSecondary">
                    {element}
                  </Typography>
                  <ClearIcon onClick={(event) => onRemoveFavoriteTokenClick(event, element)} className={cls.icon} />
                </Box>
              );
            })}
          </>
        ) : (
          <Box display="flex" justifyContent="center" width="100%">
            <Button variant="contained" color="primary" onClick={() => onAddFavoriteTokenClick()}>
              Add Tokens To Your Favorite
            </Button>
          </Box>
        )}
      </Box>
    </PaperWrapper>
  );
}
